import React from "react";
import { 
  Card, CardContent, Grid
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import I18n from "../../../../../../base/i18n.js.jsx";

import pageStyles from "../../../../../styles/page_styles.js.jsx";
import { infoPageStyles } from "../../../../base_info_page.js.jsx";
import cardStyles from "./card_styles.js";

import DateTimeFormatter from "../../../../../../utils/date_time_formatter.js";

import { AdminUserModel } from "../../../../../../models/users/admin/user_model.js";

const styles = theme => ({
});

const RegistrationInfoCard = (props) => {

  const { classes } = props;

  const user = props.user || {};
  
  const { isConfirmed, isRegistrationCompleted, registeredAt } = user;

  return (
    <Card className = { classes.card }>
      <CardContent>
        <div className = { classes.cardTitle } >
          { I18n.t("admin.users.user.field_group.registration_info")}
        </div>
        <Grid container spacing = { 3 } >
          <Grid item sm = { 12 } >
            <span className = { classes.label } >
              { `${AdminUserModel.fieldDisplayName("registeredAt")}:` }
            </span>
            {
              registeredAt  &&
              <span className = { classes.value } >
                { DateTimeFormatter.format(registeredAt) }
              </span>
            }
            {
              !registeredAt &&
              <span className = { classes.value } >
                { "-" }
              </span>
            }
          </Grid>
          <Grid item sm = { 6 } >
            <span className = { classes.label } >
              { `${AdminUserModel.fieldDisplayName("isRegistrationCompleted")}:` }
            </span>
            <span className = { classes.value } >
              { isRegistrationCompleted ? I18n.t("shared.yes_text") : I18n.t("shared.no_text") }
            </span>
          </Grid>
          <Grid item sm = { 6 } >
            <span className = { classes.label } >
              { `${AdminUserModel.fieldDisplayName("isConfirmed")}:` }
            </span>
            <span className = { classes.value } >
              { isConfirmed ? I18n.t("shared.yes_text") : I18n.t("shared.no_text") }
            </span>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

RegistrationInfoCard.defaultProps = {
}

export default withStyles(
  (theme) => ({
    ...pageStyles(theme),
    ...infoPageStyles(theme),
    ...cardStyles(theme),
    ...styles(theme)
  }),
  { withTheme: true }
)(RegistrationInfoCard);